
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('a[data-racerc-play]');
  if (!trigger || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const holder = trigger.closest('[data-racerc-video]');
  const videoId = holder?.dataset.racercVideo;
  if (!videoId || !/^[A-Za-z0-9_-]{11}$/.test(videoId)) return;
  event.preventDefault();
  const player = document.createElement('iframe');
  player.src = 'https://www.youtube-nocookie.com/embed/' + videoId + '?autoplay=1&rel=0';
  player.title = holder.dataset.videoTitle || trigger.textContent.trim();
  player.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
  player.referrerPolicy = 'strict-origin-when-cross-origin';
  player.allowFullscreen = true;
  holder.replaceChildren(player);
  player.focus();
});
